import clsx from 'clsx';

import { procedureColors } from '../../utilities/procedureColors';
import type { ModalityType, RobotTypeType } from '../../types';

type ProcedureTypeBadgeProps = {
  procedureType?: ModalityType;
  robotType?: RobotTypeType;
};

export const ProcedureTypeBadge: React.FC<ProcedureTypeBadgeProps> = ({
  procedureType,
  robotType,
}) => {
  return (
    <div
      className={clsx(
        'text-text-black text-1012 font-extrabold h-6 w-fit rounded-lg text-center mr-1 inline-flex items-center justify-center px-3',
        procedureColors[procedureType!],
      )}
    >
      {procedureType} {procedureType === 'Robotic' && robotType && `(${robotType})`}
    </div>
  );
};
